import React from "react";
import Image from "components/image";
import HeaderBag from "components/header-bag";
import { useSelector } from "react-redux";
import NextDeliveryDate from "components/next-delivery-date";
import DesktopHeaderData, { UserStatus } from "./data";
import LanguagePicker from "components/language-picker";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const DesktopHeader = ({ data, path, children }) => {
	const { authenticated } = useSelector((state) => state.account.profile);
	const { authlinks, links, logo, advertisement, customerLinks } = data;
	const displayedLinks = authenticated ? authlinks : links;
	const { isSubscriptionPage, isCollection } = useGlobalContext();

	return (
		<header className="w-full hidden lg:block sticky-header">
			<nav className="flex items-center py-6 px-6">
				<div className="flex pr-8 justify-center">
					<Image className="w-[70px]" image={logo} to={logo?.url} />
				</div>
				<nav className="w-full flex justify-start">
					<DesktopHeaderData data={displayedLinks} advertisement={advertisement} />
				</nav>

				<div className="w-1/3 gap-1 flex justify-end items-center h-5 z-50">
					{!authenticated && <div className="mr-4 relative"><LanguagePicker path={path} /></div>}
					<UserStatus customerLinks={customerLinks} path={path} />
					{authenticated && <NextDeliveryDate />}
					{!(isSubscriptionPage && isCollection) && <div className={clsx("relative", authenticated ? "ml-2" : "ml-3")}><HeaderBag /></div>}
				</div>
			</nav>
			{children}
		</header>
	);
};

export default DesktopHeader;